import { createIcon } from './createIcon'

export const TriangleArrowIcon = createIcon({
  displayName: 'VendorIcon',
  viewBox: '0 0 18 18',
  path: [
    <path
      d="M11.9681 8.12432L6.54676 3.148C6.44425 3.054 6.32709 3.00297 6.20727 3.00013C6.08745 2.99728 5.96928 3.04274 5.86488 3.13184C5.76049 3.22094 5.67361 3.35047 5.61316 3.50716C5.55271 3.66385 5.52086 3.84206 5.52087 4.02353V13.9762C5.52082 14.1577 5.55266 14.336 5.61313 14.4928C5.6736 14.6495 5.76052 14.7791 5.86497 14.8682C5.96942 14.9573 6.08764 15.0028 6.20751 14.9999C6.32738 14.997 6.44458 14.9458 6.5471 14.8517L11.9681 9.87537C12.0676 9.78421 12.1498 9.65573 12.2069 9.50236C12.264 9.34898 12.294 9.1759 12.294 8.99984C12.294 8.82379 12.264 8.65071 12.2069 8.49733C12.1498 8.34396 12.0676 8.21548 11.9681 8.12432Z"
      fill="currentColor"
    />,
  ],
})
